export default import.meta.ROLLDOWN_FILE_URL_17TxfsFjzFP3b9D6r0qR9w